/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Download_FailedInputs */

const en_file_download_failed = /** @type {(inputs: File_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File download failed`)
};

const nl_file_download_failed = /** @type {(inputs: File_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestand downloaden mislukt`)
};

/**
* | output |
* | --- |
* | "File download failed" |
*
* @param {File_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const file_download_failed = /** @type {((inputs?: File_Download_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Download_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_file_download_failed(inputs)
	return en_file_download_failed(inputs)
});